import React from 'react';

import { Avatar, Callout, Card, Delta, HUES, personColors } from '../teams/premium';
import { fmtDays } from '../teams/teamUi';

// Direct Signups (Nic 2026-10-26): veterans who made an account on their own
// with no lead before it. They go straight to being a client, so they sit
// outside every lead number on this page: this card is the only place they
// count. Accounts made in the range, and how many have signed so far.
const DirectSignupsCard = ({ direct, rangeText, vs, vsTitle }) => {
  if (!direct) return null;
  const reps = direct.byRep || [];
  const colors = personColors(reps.filter((r) => r.userId));
  return (
    <Card
      eyebrow={`Direct Signups · not leads · ${rangeText}`}
      title="Signed up on their own"
      info="Veterans who made an account themselves with no lead before it. They go straight to being a client, so none of the lead numbers above count them. Someone who was already a lead and then signed up on their own stays a lead. A Sales Rep still works each one on Signing Up."
    >
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-[13rem_1fr]">
        <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-3 lg:grid-cols-1 lg:content-start">
          <Callout color={HUES.teal} label="Accounts made" value={direct.accounts.toLocaleString('en-US')}>
            <Delta value={direct.accounts} prev={direct.prevAccounts} vs={vs} title={vsTitle} />
          </Callout>
          <Callout color={HUES.emerald} label="Signed so far" value={direct.signed.toLocaleString('en-US')}>
            <Delta value={direct.signed} prev={direct.prevSigned} vs={vs} title={vsTitle} />
          </Callout>
          <Callout color={HUES.violet} label="Account to signed" value={direct.signed ? fmtDays(direct.medianDaysToSign) : '-'}>
            median
          </Callout>
        </div>
        <div>
          <div className="mb-2 text-[10px] font-semibold uppercase tracking-wider text-slate-400">By rep</div>
          {reps.length ? (
            <ul className="m-0 list-none divide-y divide-slate-100 p-0 dark:divide-white/5">
              {reps.map((r) => (
                <li key={r.userId || 'none'} className="flex items-center gap-2.5 py-2.5">
                  <Avatar name={r.name || '-'} color={r.userId ? colors[r.userId] : HUES.slate} />
                  <span className="min-w-0 flex-1 truncate text-sm font-medium text-slate-800 dark:text-white">
                    {r.name || 'No rep'}
                  </span>
                  <span className="text-sm tabular-nums text-slate-500 dark:text-slate-400">
                    <b className="font-semibold text-slate-900 dark:text-white">{r.signed}</b> signed of {r.accounts}
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="m-0 py-6 text-center text-xs text-slate-400">
              No direct signups in this range. They count from launch on.
            </p>
          )}
        </div>
      </div>
    </Card>
  );
};

export default DirectSignupsCard;
